<template>
  <div class="resultado-toggle">
    <button
      type="button"
      class="resultado-toggle-btn"
      :class="{ active: value === 'quadrimestral' }"
      @click="$emit('input', 'quadrimestral')"
    >
      Quadrimestre
    </button>

    <button
      type="button"
      class="resultado-toggle-btn"
      :class="{ active: value === 'mensal' }"
      :disabled="disabledMensal"
      @click="!disabledMensal && $emit('input', 'mensal')"
    >
      Mês
    </button>
  </div>
</template>

<script>
export default {
  name: 'ResultadoToggle',

  props: {
    value: {
      type: String,
      default: 'quadrimestral',
    },
    disabledMensal: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style scoped lang="scss">
.resultado-toggle {
  display: inline-flex;
  align-items: center;
  background: #eef2f7;
  border: 1px solid #d7dde8;
  border-radius: 999px;
  padding: 3px;
  gap: 2px;
  margin-bottom: 15px;

  .resultado-toggle-btn {
    border: 0;
    background: transparent;
    color: #64748b;
    font-size: 12px;
    font-weight: 700;
    padding: 6px 14px;
    border-radius: 999px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      color: #2563eb;
      background: rgba(37, 99, 235, 0.08);
    }

    &.active {
      color: #fff;
      background: #0fafd7;
      box-shadow: 0 2px 6px rgba(37, 99, 235, 0.25);
    }

    &:focus {
      outline: none;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
    }
  }
}

@media (max-width: 576px) {
  .resultado-toggle {
    margin-left: 0 !important;

    .resultado-toggle-btn {
      padding: 6px 12px;
      font-size: 11px;
    }
  }
}
</style>
